import { motion } from "framer-motion";
import { Palette, Feather, Droplets, Sparkles } from "lucide-react";
import { IMAGES, WHY_CELUSTA } from "../../data/product";

const icons = [Palette, Feather, Droplets, Sparkles];

// Animation configs hoisted out of render (stable references).
const IMAGE_FADE_UP = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};
const CARD_FADE_UP = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};
const cardTransition = (delay = 0) => ({ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] });

export const WhyCelusta = () => (
  <section id="why" className="bg-[#3A2A25] scroll-mt-40 sm:scroll-mt-36" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 sm:pt-28 pb-28 sm:pb-36 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">Why Celusta</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-white">
          Simple, elevated <span className="italic text-[#C9A45C]">everyday care.</span>
        </h2>
        <p className="mt-6 text-base font-light leading-relaxed text-[#D9CCC0] max-w-md">
          CELUSTA creates thoughtful essentials for hair, body and everyday beauty — designed
          to fit effortlessly into your daily routine.
        </p>
        <motion.div
          {...IMAGE_FADE_UP}
          className="mt-10 rounded-2xl overflow-hidden max-w-md mx-auto lg:mx-0"
        >
          <img
            src={IMAGES.whyLifestyle}
            alt="Model with soft blonde curls holding the CELUSTA Leave-In Conditioner Spray"
            loading="lazy"
            className="w-full aspect-[3/4] object-cover object-top"
            data-testid="why-image"
          />
        </motion.div>
      </div>

      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
        {WHY_CELUSTA.map((item, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={item.title}
              {...CARD_FADE_UP}
              transition={cardTransition(i * 0.1)}
              className="bg-white/[0.06] border border-white/10 rounded-xl p-8 hover:bg-white/[0.1] transition-colors duration-300"
              data-testid={`why-item-${i}`}
            >
              <div className="w-11 h-11 rounded-full bg-[#C9A45C]/15 flex items-center justify-center mb-5">
                <Icon size={20} className="text-[#C9A45C]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif-display text-2xl text-white mb-3">{item.title}</h3>
              <p className="text-sm font-light leading-relaxed text-[#D9CCC0]">{item.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
